/**
 * Идентификатор запроса для идемпотентности (§22.3): повторная отправка
 * с тем же clientRequestId не создаёт второй объект.
 *
 * crypto.randomUUID браузер даёт только в защищённом контексте — по HTTPS
 * или на localhost. Сайт по IP через HTTP его не имеет: вызов бросал
 * TypeError ещё до запроса, и на боевом сервере не создавались доски,
 * роли, комментарии, связи, элементы справочников, приглашения и выгрузки.
 * crypto.getRandomValues доступен в любом контексте.
 */
export function newRequestId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  // RFC 9562, версия 4: четыре бита версии и два бита варианта.
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
